export const classes = {
  button:
    'w-18 place-center px-3 py-2 rounded hover:bg-grey-3 dark:hover:bg-white/[0.1] transition-colors',
  label: 'text-base text-grey-7 dark:text-mauve-2 cursor-pointer',
  caret: 'text-grey-6 dark:text-mauve-3 caret',
};

export const styles = {
  button: {
    '& .caret': {
      transition: 'opacity 0.1s, width 0.15s, margin-left 0.15s',
      width: 0,
      opacity: 0,
      marginLeft: 0,
    },
    '&:hover .caret': {
      opacity: 1,
      width: '1.25rem',
      marginLeft: '0.25rem',
    },
  },
};

export function formatSpeed(speed: number) {
  return `${speed < 0 ? speed.toFixed(1) : speed}x`;
}
